import { Outlet } from "react-router-dom";
import { Brand } from "@/components/Brand";
import { SiteFooter } from "@/components/SiteFooter";
import { PageErrorBoundary } from "@/components/PageErrorBoundary";

// The marketing/public shell: a sticky Brand header, the routed page in <main>,
// and the shared footer. Used for the splash, the auth flows, and the in-app
// 404 — the pre-login surface. The authenticated post-login chrome (left nav +
// account menu) lives in PortalShell (BRK-S035). Mobile-first: unprefixed
// classes describe the 375px layout; `sm:` widens it, and the `mx-auto max-w-*`
// wrappers prevent horizontal overflow at every breakpoint.
//
// The route → document.title mapping is owned one level up in RootLayout, so
// this shell no longer touches document.title (BRK-S031).
//
// The page sits in a PageErrorBoundary (BRK-S032), as the portal's does: a
// throw on a public page (splash, sign-in, terms) keeps this header and footer.
//
// It follows the theme like the portal (BRK-S249): the page is brk-bg under a
// brk-panel header and footer, so white with Ink type by day and Ink by night.
// It was a dark canvas in both schemes until then.
export function AppShell() {
  return (
    <div className="flex min-h-full flex-col bg-brk-bg text-brk-text">
      <header className="sticky top-0 z-10 border-b border-brk-border bg-brk-panel">
        <div className="mx-auto flex w-full max-w-5xl items-center justify-between px-4 py-5 sm:px-6 sm:py-6">
          <Brand size="sm" />
        </div>
      </header>

      <main className="mx-auto w-full max-w-5xl flex-1 px-4 py-8 sm:px-6 sm:py-12">
        <PageErrorBoundary homeTo="/" homeLabel="Back to home">
          <Outlet />
        </PageErrorBoundary>
      </main>

      <SiteFooter />
    </div>
  );
}
